import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listSessions, type SessionListItem } from '../api/sessions';

function fmtDuration(ms: number): string {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
  return h > 0 ? `${h}h ${String(m).padStart(2, '0')}m` : `${m}:${String(s % 60).padStart(2, '0')}`;
}
function fmtDist(m: number): string {
  return m >= 1000 ? `${(m / 1000).toFixed(2)} km` : `${Math.round(m)} m`;
}

export default function SessionsPage() {
  const [rows, setRows] = useState<SessionListItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    listSessions().then((r) => { setRows(r); setLoading(false); }).catch((e) => { setErr(String(e)); setLoading(false); });
  }, []);

  if (loading) return <div className="p-6 text-slate-400">Loading sessions…</div>;
  if (err) return <div className="p-6 text-rose-400">Error: {err}</div>;
  if (rows.length === 0) return <div className="p-6 text-slate-400">No sessions yet.</div>;

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold text-white mb-4">Sessions <span className="text-slate-500 text-sm font-normal">({rows.length})</span></h1>
      <div className="rounded-xl border border-slate-800 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-900 text-slate-400 text-xs uppercase tracking-wide">
            <tr>
              <th className="text-left px-4 py-3">Date</th>
              <th className="text-right px-4 py-3">Duration</th>
              <th className="text-right px-4 py-3">Distance</th>
              <th className="text-right px-4 py-3">Points</th>
              <th className="text-right px-4 py-3">Avg RSRP</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-800">
            {rows.map((s) => {
              const dur = new Date(s.endedAt).getTime() - new Date(s.startedAt).getTime();
              return (
                <tr key={s.sessionId} className="hover:bg-slate-900/60">
                  <td className="px-4 py-3 text-slate-200 font-mono text-xs">{new Date(s.startedAt).toLocaleString()}</td>
                  <td className="px-4 py-3 text-right text-slate-300">{fmtDuration(dur)}</td>
                  <td className="px-4 py-3 text-right text-slate-300">{fmtDist(s.distanceM)}</td>
                  <td className="px-4 py-3 text-right text-slate-300">{s.pointCount}</td>
                  <td className="px-4 py-3 text-right text-slate-300">{s.avgRsrp != null ? `${s.avgRsrp.toFixed(1)} dBm` : '—'}</td>
                  <td className="px-4 py-3 text-right">
                    <Link to={`/sessions/${encodeURIComponent(s.sessionId)}`} className="text-emerald-400 hover:underline">Open →</Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
